export default __webpack_public_path__ + "static/agrocannabis600-6feb577d8d77d362e486f74b168eca57.png";